import { NamedModelEntityReference } from '@upright/common/model/input/types';
import { BouLink } from '@upright/ui/common/generic/content/texts/bou-link';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import {
  apple,
  cargotec,
  fiskars,
  lamor,
  securitas,
  shell,
  siemens,
  taaleri,
  tesla,
  uponor,
  vaisala,
} from '@upright/ui/common/upright/model/output/search/header-search/example-searches';
import { getModelEntityUrl } from '@upright/ui/untidy/urls';
import { useMemo } from 'react';
import { BoxCta } from './common/box-cta';

function getExampleProfiles(lens: ImpactLensType): NamedModelEntityReference[] {
  switch (lens) {
    case ImpactLensType.TARGETS:
      return [fiskars, taaleri, tesla];
    case ImpactLensType.INSIGHTS:
      return [securitas, vaisala, cargotec];
    case ImpactLensType.UPRIGHT_NET_IMPACT:
      return [siemens, tesla, apple];
    case ImpactLensType.SDGS:
      return [tesla, uponor, lamor];
    case ImpactLensType.EU_TAXONOMY:
    case ImpactLensType.EU_PAIS:
      return [siemens, apple, shell];
    default:
      return [];
  }
}

export function EmptyStateExampleCompanyProfilesCTA() {
  const context = useCarouselContext();
  const lensType = context.lensType;

  // memoize test, no need to actually memoize this
  return useMemo(() => {
    const examples = getExampleProfiles(lensType);
    return (
      <BoxCta title="View example profiles">
        Want to see what this data typically looks like? Visit one of these companies:{' '}
        {examples.map((ref, index) => {
          return (
            <span key={ref.id}>
              <BouLink to={getModelEntityUrl(ref.type, ref.id, ref.name, lensType)}>{ref.name}</BouLink>
              {index < examples.length - 1 ? ', ' : undefined}
            </span>
          );
        })}
        .
      </BoxCta>
    );
  }, [lensType]);
}
